import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/secondary-school/layoutProps';
import ichk from '../../../../../static/ichk.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="through-train-to-ichk">
    <h1>一條龍中學 ICHK</h1>
    <p>
      ICHK乃京斯敦國際學校的直屬中學，該校提供中學學位予本校所有的畢業生，讓他們接受優質的國際文憑教育。ICHK承諾致力為學生提供前瞻性及以探索研究為主導的教育。正因如此，學校設立小班教學，並提供個人化及創新的課程，校園綠化及寬敞的環境，教師熱心教學，校園環境溫馨舒適。
    </p>
    <p>
      ICHK的學生獲受全球認可的學術資歷，學生建立了一定的生活技能：批判思維能力、領導才能、個人毅力、團體合作及個人學習能力。
    </p>
    <a
      href="https://www.ichk.edu.hk/home/our-school/secondary/"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.ichk}
    >
      <img src={ichk} alt="ICHK" />
    </a>
  </ContentLayout>
);
